<div class="container-fluid header_bg">
  <div class="row align-items-center">
      <div class="col-lg-5 col-md-5 col-6 logo">
          <img src="/assets/images/ots_logo.png" class="img-fluid" alt="OTS Logo">
      </div>
      <div [hidden]="unAuthorizedUser" class="col-lg-7 col-md-7 col-6 user_main dropdown"
          >
          <span class="fa fa-user user_icon" data-bs-toggle="dropdown" (click)="toggleDropdown()"></span>
          <ul class="dropdown-menu" [ngClass]="{'show': dropdownOpen}">
              <li><span class="fa fa-caret-up drop_downicon"></span></li>
              <li *ngIf="userRoleId == 0">
                  <a class="dropdown-item" style="cursor:pointer" (click)="ExternalInvoice()">
                      <span class="fa fa-asterisk"></span> Home
                  </a>
              </li>
              <li *ngIf="userRoleId == 1">
                  <a class="dropdown-item" style="cursor:pointer" (click)="Admin()">
                      <span class="fa fa-asterisk"></span> Admin
                  </a>
              </li>
              <li *ngIf="userRoleId == 0">
                  <a class="dropdown-item" style="cursor:pointer" (click)="ChangePassword()">
                      <span class="fa fa-asterisk"></span> Change Password
                  </a>
              </li>
              <li *ngIf="userRoleId == 3">
                  <a class="dropdown-item" style="cursor:pointer" (click)="RefundHome()">
                      <span class="fa fa-asterisk"></span> Home
                  </a>
              </li>
              <li *ngIf="userRoleId == 4">
                  <a class="dropdown-item" style="cursor:pointer" (click)="RefundApproveHome()">
                      <span class="fa fa-asterisk"></span> Home
                  </a>
              </li>
              <li *ngIf="userRoleId == 3">
                  <a class="dropdown-item" style="cursor:pointer" (click)="InternalInvoice()">
                      <span class="fa fa-asterisk"></span> Invoice/Orders
                  </a>
              </li>
              <li *ngIf="userRoleId == 4">
                  <a class="dropdown-item" style="cursor:pointer" (click)="InternalInvoice()">
                      <span class="fa fa-asterisk"></span> Invoice/Orders
                  </a>
              </li>
              <li>
                  <a class="dropdown-item" style="cursor:pointer" (click)="logoutUser()">
                      <span class="fa fa-sign-out"></span> Logout
                  </a>
              </li>
              <li>
                  <a class="dropdown-item" style="cursor:pointer" (click)="HelpPopup()">
                      <span class="fa fa-question-circle"></span> Help
                  </a>
              </li>
          </ul>

          <div [ngClass]="{'nameAlone': Info == 0 || Info == null}" class="fw-bold">
              {{ userloggedin }}<br>
              <span *ngIf="Info == 0" >External User</span>
              <span *ngIf="Info == 1">Admin</span>
              <span *ngIf="Info == 2">Account Executive</span>
              <span *ngIf="Info == 3">Credit Manager</span>
              <span *ngIf="Info == 4">Credit Manager Admin</span>
          </div>
      </div>
  </div>
</div>

<div [hidden]="!unAuthorizedUser" class="unauthorizedUser">
  You are not an authorized User!
</div>

<p-dialog header="Help" [(visible)]="displayHelpPopUp" [modal]="true" [style]="{ width: '362px', minWidth: '362px' }"
  [closable]="false" [blockScroll]="true" [baseZIndex]="10000">
  <div>
      <!-- <label>Please Contact Admin at MediaPay.Support@nbcuni.com</label> -->
      <p><a href="../../assets/MediaPay User Guide.pdf" target="_blank"> MediaPay User Guide</a></p>
  </div>
  <p-footer>
      <button type="submit" pButton Class="ui-button-success" (click)="onClickOk();" label="OK">
      </button>
  </p-footer>

</p-dialog>
